// Static layout classes shared by the session tabs (Agenda, Action Items).
// Animations live in styles/motion.js — keep this file motion-free.
import { css } from "@emotion/css";
import { SESSION_TAB_BODY_HEIGHT } from "./insights.constants";

/**
 * Stacks children in the same grid cell so they overlay without absolute positioning
 * (conventions doc: prefer a grid stack over position:absolute + inset). The tallest child
 * drives the height, so siblings can crossfade in place without the row resizing.
 */
export const gridStackClass = css({
  display: "grid",
  "& > *": { gridArea: "1 / 1" },
});

/**
 * Tab body: a bounded flex column so the list scrolls internally instead of growing the page
 * and pushing the footer down.
 */
export const tabBodyClass = css({
  display: "flex",
  flexDirection: "column",
  height: SESSION_TAB_BODY_HEIGHT,
});

/**
 * Scrollable region inside tabBodyClass. `flex: 0 1 auto` lets it shrink to the available space
 * rather than stretch, and `minHeight: 0` is required for a flex child to scroll at all.
 */
export const tabScrollClass = css({
  flex: "0 1 auto",
  minHeight: 0,
  overflowY: "auto",
});
